module.exports = __webpack_public_path__ + "img/1523135751.93af664a.jpg";